import React, { useEffect, useState } from 'react';
import Compressor from 'compressorjs';
import axios from 'axios';

const useProfileChange = (file = null, upKey = null, delKey = null) => {
  const [profileProgress, setProfileProgress] = useState(0);
  const [profileUrl, setProfileUrl] = useState('');
  const [profileKey, setProfileKey] = useState('');

  // Delete from backend
  useEffect(() => {
    if (delKey) {
      const handleDelete = async () => {
        try {
          console.log('Deleting file with key:', delKey);
          await axios.post('/api/delete-image', { key: delKey });
          console.log('Profile picture deleted:', delKey);
          setProfileUrl('');
          setProfileKey('');
        } catch (err) {
          console.error('Failed to delete profile picture:', err);
        }
      };
      handleDelete();
    }
  }, [delKey]);

  // Upload profile picture via backend
  useEffect(() => {
    if (!file) return;

    console.log('Starting upload with file:', file);

    new Compressor(file, {
      quality: 0.8,
      maxWidth: 500,
      maxHeight: 500,
      success: async (compressedFile) => {
        console.log('Compression successful, uploading...');
        const fData = new FormData();
        fData.append('image', compressedFile);
        fData.append('filePath', upKey + '/');
        fData.append('content_type', compressedFile.type);

        try {
          console.log('Making API request to /api/upload-image');
          const response = await axios.post('/api/upload-image', fData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (evt) => {
              const progressPercentage = Math.round(
                (evt.loaded * 100) / evt.total
              );
              console.log('Upload progress:', progressPercentage);
              setProfileProgress(progressPercentage);
            },
          });

          console.log('Upload response:', response.data);
          if (response?.data?.url) {
            setProfileUrl(response.data.url);
            setProfileKey(response.data.Key);
            setProfileProgress(100);
          }
        } catch (err) {
          console.error('Profile picture upload failed:', err.response?.data || err.message);
          setProfileProgress(0);
        }
      },
      error: (err) => {
        console.error('Profile picture compression failed:', err);
        setProfileProgress(0);
      },
    });
  }, [file, upKey]);

  return [profileUrl, profileKey, profileProgress];
};

export default useProfileChange;